<button
  [ngClass]="flavorToClass[flavor]"
  [disabled]="disabled"
  (click)="clicked.emit()"
  class="flex gap-1 px-3 py-1 items-center rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
  clickStopPropagation
>
  <flx-icon [name]="iconName" />
  <span class="text-sm font-semibold">{{ label }}</span>
</button>
